import React from 'react';
import specialColumns from './specialColumns';
import PhoneNumber from '../../../components/PhoneNumber/PhoneNumber';
import MobileApplication from '../components/MobileApplication/MobileApplication';

const tableColumns = (noticeId, noticeTypeView, debtorStates) => {
  return [
    {
      title: 'Номер ЛС',
      dataIndex: 'account',
      sorter: (a, b) => {
        if (a.account < b.account) {
          return -1;
        }
        if (a.account === b.account) {
          return 0;
        }
        if (a.account > b.account) {
          return 1;
        }
      },
    },
    {
      title: 'Собственники',
      dataIndex: 'name',
    },
    {
      title: 'Адрес',
      dataIndex: 'address',
      sorter: (a, b) => {
        if (a.address < b.address) {
          return -1;
        }
        if (a.address === b.address) {
          return 0;
        }
        if (a.address > b.address) {
          return 1;
        }
      },
    },
    {
      title: 'МП',
      dataIndex: 'hasMobileApplication',
      sorter: (a, b) => {
        if (a.hasMobileApplication < b.hasMobileApplication) {
          return -1;
        }
        if (a.hasMobileApplication === b.hasMobileApplication) {
          return 0;
        }
        if (a.hasMobileApplication > b.hasMobileApplication) {
          return 1;
        }
      },
      filters: [
        { text: 'Есть МП у собственника', value: true },
        { text: 'Нет МП у собственника', value: false },
      ],
      onFilter: (value, record) => record.hasMobileApplication === value,
      render: (hasMobileApplication, record) => {
        return (
          <MobileApplication hasMobileApplication={hasMobileApplication} />
        );
      },
    },
    {
      title: 'Телефон',
      dataIndex: 'phone',
      render: (phone, record) => {
        if (!phone) {
          return null;
        }

        return (
          <PhoneNumber
            phoneNumber={phone}
            name={record.name}
          />
        );
      },
    },
    {
      title: 'Почта',
      dataIndex: 'email',
      sorter: (a, b) => {
        if (a.email < b.email) {
          return -1;
        }
        if (a.email === b.email) {
          return 0;
        }
        if (a.email > b.email) {
          return 1;
        }
      },
      filters: [
        { text: 'Есть почта у собственника', value: 'yes' },
        { text: 'Нет почты у собственника', value: 'no' },
      ],
      onFilter: (value, record) => {
        if (value === 'yes') return record.email && record.email.trim() !== '';
        if (value === 'no') return !record.email || record.email.trim() === '';
        return true;
      },
    },
    ...specialColumns(noticeId, noticeTypeView, debtorStates),
  ];
};

export default tableColumns;
